/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { RowProps } from './Row.props';

/**
 * SDS Row component.
 */
export const Row = (props: RowProps): JSX.Element => {
  const { children, classes, title, subtitle, border = true, button, ...rest } = props;

  const rowClass = clsx(`sds-row`, classes, {
    'sds-row--border': border,
  });
  const displayHeader = title || subtitle || button;
  return (
    <div
      className={clsx(rowClass, [
        {
          'no-border': !border,
          'no-children': !children,
        },
      ])}
      {...rest}
    >
      {displayHeader && (
        <div className={'sds-row__header'}>
          <div className="sds-row__header-text">
            {title && <span className="sds-row__title">{title}</span>}
            {subtitle && <span className="sds-row__subtitle">{subtitle}</span>}
          </div>
          {button && (
            <div className="sds-row__header-actions">
              <div className="sds-row__header-button">{button}</div>
            </div>
          )}
        </div>
      )}
      {children && <div className="sds-row__body">{children}</div>}
    </div>
  );
};
